export default __webpack_public_path__ + "static/media/jnlp.95843b94.png";